import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';

interface IMyProps {
  show: boolean;
  executing?: boolean;
  handleAcaoPrincipal?: (motivo?: string) => void;
  handleAcaoSecundaria?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleHide: (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement>
      | HTMLElement,
  ) => void;
  tituloDaCaixaDeTexto?: string;
  corpoDaCaixaDeTexto?: string;
  tituloBotaoPrincipal?: string;
  tituloBotaoSecundario?: string;
}

export default function ModalConfirmarAcao({
  show,
  executing,
  handleAcaoPrincipal,
  handleAcaoSecundaria,
  handleHide,
  tituloDaCaixaDeTexto,
  tituloBotaoPrincipal,
  corpoDaCaixaDeTexto,
  tituloBotaoSecundario,
}: IMyProps) {
  const [motivo, setMotivo] = useState<string>('');

  // Exibe o campo de justificativa apenas quando houver botão de "Rejeitar" (principal ou secundário)
  const mostrarCampoJustificativa =
    (tituloBotaoPrincipal?.toLowerCase().includes('rejeitar') ?? false) || (tituloBotaoSecundario && tituloBotaoSecundario?.length > 0);

  const handleClose = (e: React.MouseEvent<HTMLButtonElement> | HTMLElement) => {
    setMotivo('');
    handleHide(e);
  };

  const handleAcaoPrincipalClick = () => {
    if (handleAcaoPrincipal) {
      handleAcaoPrincipal(motivo);
    }
  };

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onExit={handleClose}
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter">
          {tituloDaCaixaDeTexto}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{corpoDaCaixaDeTexto}</p>
        {mostrarCampoJustificativa && (
          <Form.Group className="mt-3">
            <Form.Control
              as="textarea"
              rows={1}
              value={motivo}
              onChange={(e) => setMotivo(e.target.value)}
              placeholder="Justificativa (opcional)."
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer className="text-left">
        {tituloBotaoPrincipal && (
          <Button
            variant="primary"
            onClick={handleAcaoPrincipalClick}
            className="btn-success text-left"
            disabled={executing}
          >
            {executing ? 'Aguarde...' : tituloBotaoPrincipal}
          </Button>
        )}
        {tituloBotaoSecundario && (
          <Button
            variant="primary"
            onClick={handleAcaoSecundaria}
            className="btn-primary text-left"
          >
            {tituloBotaoSecundario}
          </Button>
        )}
        <Button variant="secondary" onClick={handleClose}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
